import React from 'react';
import {Row, Col} from 'antd';
import './Learn.css';
import padImg from '../../Assests/assets/images/report.png';
import magnifyingGlassImg from '../../Assests/assets/images/magnifying-glass.png';
import billImg from '../../Assests/assets/images/bill.png';
import miscImg from '../../Assests/assets/images/scheme.png';

const Learn = (props) => {
  return (
    <div class='learn-container-bg'>
    <div class='learn-container'>
      <span class='learn-title'>What you'll learn?</span>
      <Row className='learn-contents-container'>
        <Col sm={24} md={12} lg={6} className='learn-contents-elem-container'>
          <div class='learn-contents-rect'>
            <span class='learn-contents-img-container'>
              <img src = {billImg} class='learn-contents-img'/>
            </span>
            <span class='learn-contents-text'>
              Line by line components in the Financial Statements
            </span>
          </div>
        </Col>
        <Col sm={24} md={12} lg={6} className='learn-contents-elem-container'>
          <div class='learn-contents-rect'>
            <span class='learn-contents-img-container'>
              <img src = {padImg}/>
            </span>
            <span class='learn-contents-text'>
              Format of the 
              Financial Statements
            </span>
          </div>
        </Col>
        <Col sm={24} md={12} lg={6} className='learn-contents-elem-container'>
          <div class='learn-contents-rect'>
            <span class='learn-contents-img-container'>
              <img src = {magnifyingGlassImg}/>
            </span>
            <span class='learn-contents-text'>
              Tools to 
              analyse the 
              Financial Statements
            </span>
          </div>
        </Col>
        <Col sm={24} md={12} lg={6} className='learn-contents-elem-container'>
          <div class='learn-contents-rect'>
            <span class='learn-contents-img-container'>
              <img src = {miscImg}/>
            </span>
            <span class='learn-contents-text'>
              Drawing logical 
              inferences based on the calculations using the tools
            </span>
          </div>
        </Col>
      </Row>
    </div>
    </div>
  )
}
export default Learn;
